module.exports = __webpack_public_path__ + "static/media/qualite.2530e94b.jpg";